import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './Impressum.css';

const Impressum: React.FC = () => {
  const { t } = useLanguage();
  const { impressum } = t;

  return (
    <div className="impressum">

      <section className="page-hero">
        <div className="page-hero__overlay" />
        <div className="page-hero__content container">
          <div className="section-label section-label--light">{impressum.pageLabel}</div>
          <h1 className="page-hero__headline">{impressum.heroTitle}</h1>
        </div>
      </section>

      <section className="section">
        <div className="container impressum__content">

          <div className="impressum__block">
            <h2>MahMedix</h2>
            <address>
              Ernst-Thälmann Ring 64 a<br />
              17491 Greifswald<br />
              Mecklenburg-Vorpommern, Germany
            </address>
          </div>

          <div className="impressum__block">
            <h3>{impressum.contactInfoTitle}</h3>
            <ul className="impressum__contact-list">
              <li>
                <span className="impressum__contact-label">Phone:</span>
                <a href="tel:+4938344398063">(+49) 38344398063</a>
              </li>
              <li>
                <span className="impressum__contact-label">Email:</span>
                <a href="mailto:info@mahmedix.de">Info@mahmedix.de</a>
              </li>
              <li>
                <span className="impressum__contact-label">Website:</span>
                <a href="https://mahmedix.de/" target="_blank" rel="noopener noreferrer">
                  https://mahmedix.de/
                </a>
              </li>
            </ul>
          </div>

          <div className="impressum__block">
            <h3>{impressum.registerTitle}</h3>
            <ul className="impressum__contact-list">
              <li>
                <span className="impressum__contact-label">{impressum.register}:</span>
                <span>Hansestadt Greifswald</span>
              </li>
              <li>
                <span className="impressum__contact-label">{impressum.municipality}:</span>
                <span>13075039</span>
              </li>
            </ul>
          </div>

          <div className="impressum__block">
            <h3>{impressum.responsibleTitle}</h3>
            <p>{impressum.responsibleBody}</p>
          </div>

          <div className="impressum__block">
            <h3>{impressum.liabilityContentTitle}</h3>
            <p>{impressum.liabilityContentBody}</p>
          </div>

          <div className="impressum__block">
            <h3>{impressum.liabilityLinksTitle}</h3>
            <p>{impressum.liabilityLinksBody}</p>
          </div>

          <div className="impressum__block">
            <h3>{impressum.copyrightTitle}</h3>
            <p>{impressum.copyrightBody}</p>
          </div>

        </div>
      </section>
    </div>
  );
};

export default Impressum;
